import * as React from 'react';
import { Security } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';
import { toRelativeUrl, OktaAuth } from '@okta/okta-auth-js';

import { getOktaAuth } from './oktaAuthInstance';
import { oktaConfig } from './oktaConfig';

type Props = { children: React.ReactNode };

/**
 * Wraps the app in Okta's <Security> provider.
 *
 * MUST be rendered inside a Router (uses react-router-dom v5 history).
 * Only mount this when Okta is enabled — see index.tsx.
 */
export const OktaProvider: React.FC<Props> = ({ children }) => {
    const history = useHistory();

    const restoreOriginalUri = React.useCallback(
        (_oktaAuth: OktaAuth, originalUri: string) => {
            history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
            return Promise.resolve();
        },
        [history]
    );

    if (!oktaConfig.issuer || !oktaConfig.clientId) {
        throw new Error(
            'Okta is not configured. Set REACT_APP_OKTA_ISSUER and REACT_APP_OKTA_CLIENT_ID in .env.development.local and restart the dev server.'
        );
    }

    return (
        <Security oktaAuth={getOktaAuth()} restoreOriginalUri={restoreOriginalUri}>
            {children}
        </Security>
    );
};
